import type { MigrateToAutomaticTaxRequestPayload, MigrateToAutomaticTaxResponse } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../../services/api';

export function useMigrateToAutomaticTax(
  options?: UseMutationOptions<MigrateToAutomaticTaxResponse, unknown, MigrateToAutomaticTaxRequestPayload>,
) {
  return useMutation(async (migrateToAutomaticTaxRequest) => {
    const api = getPrivateApi();

    return api.migrateToAutomaticTax({ migrateToAutomaticTaxRequest });
  }, options);
}
